var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { arrow, autoUpdate, computePosition, flip, shift, } from '@floating-ui/dom';
import { html, render } from 'lit';
import { property, query, queryAssignedElements, state } from 'lit/decorators.js';
import { isEmpty, isNil, throttle, uniqueId } from 'lodash-es';
import { appendStylesToTheGlobalStyleRoot } from '../utilities/dom';
import { translate } from '../utilities/translate';
import stylesGlobal from './_sds-popover-global.lit.scss';
import { getClass, PopoverClass } from './popover-class';
import { convertToFloatingUi, getPlacementWithoutAlignment, getPositionClassName, shiftPopover, tryPlacements, } from './popover-position';
import { ExpandableContainerLit } from './expandable-container.lit';
import styles from './sds-popover.lit.scss';
import { sdsCustomElement } from '../utilities/custom-components';
/**
 * `sds-popover` is a component that displays a contextual overlay, such as a tooltip or informational pop-up.
 * It can be positioned relative to the target in various directions.
 *
 * ### Attributes
 * - `position`: Placement of the popover relative to the target element.
 * - `heading`: The main heading or title displayed within the popover.
 * - `trigger-type`: How the popover is triggered - 'hover' (default) or 'click'.
 *
 * @tag sds-popover
 */
let SdsPopover = (() => {
    var _SdsPopover_openOn_accessor_storage, _SdsPopover__trigger_accessor_storage, _SdsPopover__opened_accessor_storage, _SdsPopover_contentSlot_accessor_storage, _SdsPopover_textSlot_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-popover')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = ExpandableContainerLit;
    let _instanceExtraInitializers = [];
    let _set_position_decorators;
    let _openOn_decorators;
    let _openOn_initializers = [];
    let _openOn_extraInitializers = [];
    let __trigger_decorators;
    let __trigger_initializers = [];
    let __trigger_extraInitializers = [];
    let __opened_decorators;
    let __opened_initializers = [];
    let __opened_extraInitializers = [];
    let _contentSlot_decorators;
    let _contentSlot_initializers = [];
    let _contentSlot_extraInitializers = [];
    let _textSlot_decorators;
    let _textSlot_initializers = [];
    let _textSlot_extraInitializers = [];
    var SdsPopover = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsPopover_openOn_accessor_storage.set(this, (__runInitializers(this, _instanceExtraInitializers), __runInitializers(this, _openOn_initializers, 'hover')));
            _SdsPopover__trigger_accessor_storage.set(this, (__runInitializers(this, _openOn_extraInitializers), __runInitializers(this, __trigger_initializers, void 0)));
            this._position = (__runInitializers(this, __trigger_extraInitializers), 'top');
            _SdsPopover__opened_accessor_storage.set(this, __runInitializers(this, __opened_initializers, false));
            this._clearAutoPositioner = (__runInitializers(this, __opened_extraInitializers), undefined);
            /**
             * Delay when the popover component is being hovered.
             * @type {any}
             */
            this._unique = uniqueId('sds-popover');
            this._popover = document.createElement('div');
            this._footerContainer = null;
            this._popoverHeight = 0;
            this._popoverOffset = 6;
            _SdsPopover_contentSlot_accessor_storage.set(this, __runInitializers(this, _contentSlot_initializers, void 0));
            _SdsPopover_textSlot_accessor_storage.set(this, (__runInitializers(this, _contentSlot_extraInitializers), __runInitializers(this, _textSlot_initializers, void 0)));
            this.contentChangingHandler = (__runInitializers(this, _textSlot_extraInitializers), throttle(() => this.onContentChange(), 100, {
                leading: true,
                trailing: true,
            }));
            this._popoverOpeningHandler = () => {
                if (!this._opened) {
                    this._timer = setTimeout(() => void this.openPopover().then().catch(console.error), 100);
                }
            };
            this._popoverClosingTriggerHandler = (event) => {
                // when mouse gets on popover, don't remove it
                if (event.relatedTarget !== this._popover) {
                    if (!(event.relatedTarget instanceof HTMLDivElement) ||
                        event.relatedTarget.parentElement !== this._popover) {
                        clearTimeout(this._timer);
                        this.closePopover();
                    }
                }
            };
            this._popoverClosingPopoverHandler = (event) => {
                // when mouse gets on trigger, don't remove popover
                if (!isNil(event.relatedTarget) && event.relatedTarget !== this.getTriggerStrict()) {
                    this.closePopover();
                }
            };
            this.modalClosedListener = () => {
                for (const child of this._modalContainer.children) {
                    this._contentContainer.append(child);
                }
                this._modalContainer.remove();
            };
            // Click event handlers for click trigger type
            this.togglePopoverOnClick = (event) => {
                var _a, _b;
                event.stopPropagation();
                if (this._opened) {
                    this.closePopover();
                    (_a = this.getTrigger()) === null || _a === void 0 ? void 0 : _a.removeAttribute('selected');
                }
                else {
                    this.openPopover().catch(console.error);
                    (_b = this.getTrigger()) === null || _b === void 0 ? void 0 : _b.setAttribute('selected', 'true');
                }
            };
            this.outsideClickHandler = (event) => {
                var _a;
                if (!this._opened)
                    return;
                const target = event.target;
                if (!this._popover.contains(target) && !this.getTriggerStrict().contains(target)) {
                    this.closePopover();
                    (_a = this.getTrigger()) === null || _a === void 0 ? void 0 : _a.removeAttribute('selected');
                }
            };
        }
        static removeElementIfExists(element) {
            if (element) {
                element.remove();
            }
        }
        /**
         * Placement of the popover relative to the target element.
         * Possible values include:
         * - `'up'`: Positions the popover above the target.
         * - `'down'`: Positions the popover below the target.
         * - `'left'`: Positions the popover to the left of the target.
         * - `'right'`: Positions the popover to the right of the target.
         *
         * @attr {string} position - Placement of the popover.
         */
        set position(value) {
            this._position = convertToFloatingUi(value);
        }
        /**
         * How the popover should be triggered
         * - "hover" - Opens on mouseenter, closes on mouseleave
         * - "click" (default) - Toggles on click, closes when clicking outside
         *
         * @attr {string} open-on - How the popover is triggered.
         */
        get openOn() { return __classPrivateFieldGet(this, _SdsPopover_openOn_accessor_storage, "f"); }
        set openOn(value) { __classPrivateFieldSet(this, _SdsPopover_openOn_accessor_storage, value, "f"); }
        get _trigger() { return __classPrivateFieldGet(this, _SdsPopover__trigger_accessor_storage, "f"); }
        set _trigger(value) { __classPrivateFieldSet(this, _SdsPopover__trigger_accessor_storage, value, "f"); }
        get _opened() { return __classPrivateFieldGet(this, _SdsPopover__opened_accessor_storage, "f"); }
        set _opened(value) { __classPrivateFieldSet(this, _SdsPopover__opened_accessor_storage, value, "f"); }
        get contentSlot() { return __classPrivateFieldGet(this, _SdsPopover_contentSlot_accessor_storage, "f"); }
        set contentSlot(value) { __classPrivateFieldSet(this, _SdsPopover_contentSlot_accessor_storage, value, "f"); }
        get textSlot() { return __classPrivateFieldGet(this, _SdsPopover_textSlot_accessor_storage, "f"); }
        set textSlot(value) { __classPrivateFieldSet(this, _SdsPopover_textSlot_accessor_storage, value, "f"); }
        render() {
            return html `
            <slot name="trigger"></slot>
            <slot name="text"></slot>
            <slot name="content"></slot>
        `;
        }
        connectedCallback() {
            super.connectedCallback();
            if (!isNil(this.getTrigger())) {
                this.onContentChange();
                this.textSlot.addEventListener('slotchange', this.contentChangingHandler);
                this.contentSlot.addEventListener('slotchange', this.contentChangingHandler);
            }
        }
        disconnectedCallback() {
            var _a;
            super.disconnectedCallback();
            const trigger = this.getTrigger();
            if (trigger) {
                // Remove hover event listeners
                trigger.removeEventListener('mouseenter', this._popoverOpeningHandler);
                trigger.removeEventListener('mouseleave', this._popoverClosingTriggerHandler);
                // Remove click event listeners
                trigger.removeEventListener('click', this.togglePopoverOnClick);
            }
            else {
                console.warn('trigger is undefined some listeners will not be removed');
            }
            // Remove popover and document event listeners
            this._popover.removeEventListener('mouseleave', this._popoverClosingPopoverHandler);
            document.removeEventListener('click', this.outsideClickHandler);
            (_a = document
                .querySelector('sds-modal')) === null || _a === void 0 ? void 0 : _a.removeEventListener('sds.modal.closed', this.modalClosedListener);
            this.removePopover();
            clearTimeout(this._timer);
            this.textSlot.removeEventListener('slotchange', this.contentChangingHandler);
            this.contentSlot.removeEventListener('slotchange', this.contentChangingHandler);
        }
        firstUpdated(_changedProperties) {
            super.firstUpdated(_changedProperties);
            this.onContentChange();
            this.textSlot.addEventListener('slotchange', this.contentChangingHandler);
            this.contentSlot.addEventListener('slotchange', this.contentChangingHandler);
        }
        /**
         *  Return trigger html
         */
        getTrigger() {
            return this._trigger[0];
        }
        async updated(_changedProperties) {
            await this.updateComplete;
            if (_changedProperties.has('heading')) {
                this.addTitle();
            }
            super.updated(_changedProperties);
        }
        async openPopover() {
            var _a;
            this._opened = true;
            this._popover.style.opacity = '0';
            this.addPopover();
            await this.setBodyOverflows();
            await this.addActions();
            this.setPopoverHeight();
            this._currentPlacement = tryPlacements((_a = this.getTriggerStrict()) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect(), this._position, this._popoverHeight, this._popoverOffset);
            this.updatePosition();
            this._popover.style.opacity = '1';
        }
        closePopover() {
            this._opened = false;
            this.removePopover();
        }
        onContentChange() {
            appendStylesToTheGlobalStyleRoot('sds-popover', stylesGlobal.cssText);
            this.prepareTrigger();
            this.preparePopover();
        }
        collapseContainer() {
            if (this._showMoreButton) {
                super.collapse(this._contentContainer, 'sds-popover__content--expanded');
                this.revealShowMore();
                this.hideReadAll();
            }
        }
        async expandContainer() {
            if (this._showMoreButton) {
                this.removeWithShowMoreClass();
                super.expand(this._contentContainer, 'sds-popover__content--expanded');
                this.hideShowMore();
                await this.addReadAll();
                this.setToggleContainerStyle();
            }
        }
        getTriggerStrict() {
            const trigger = this.getTrigger();
            if (isNil(trigger)) {
                throw new Error('Trigger is undefined');
            }
            return trigger;
        }
        async addActions() {
            this.addToggle();
            await this.addReadAll();
            this.setToggleContainerStyle();
        }
        setToggleContainerStyle() {
            if (this._toggleContainer) {
                for (const child of this._toggleContainer.children) {
                    if (child.style.display !== 'none') {
                        if (!this._toggleContainer.classList.contains('sds-popover__show-more')) {
                            this._toggleContainer.classList.add('sds-popover__show-more');
                        }
                        return;
                    }
                }
                this._toggleContainer.classList.remove('sds-popover__show-more');
            }
        }
        prepareTrigger() {
            const trigger = this.getTrigger();
            if (!isNil(trigger)) {
                trigger.setAttribute('sds-popover', this._unique);
                if (this.openOn === 'hover') {
                    trigger.addEventListener('mouseenter', this._popoverOpeningHandler);
                    trigger.addEventListener('mouseleave', this._popoverClosingTriggerHandler);
                    this._popover.addEventListener('mouseleave', this._popoverClosingPopoverHandler);
                }
                if (this.openOn === 'click') {
                    trigger.addEventListener('click', this.togglePopoverOnClick);
                    document.addEventListener('click', this.outsideClickHandler);
                }
            }
        }
        preparePopover() {
            this._popover.setAttribute('sds-popover', this._unique);
            this.clearPopoverClasses();
            this.addTitle();
            this.addContent();
            this.addFooter();
            this.addArrow();
            this.reopenPopoverOnSlotChange();
        }
        reopenPopoverOnSlotChange() {
            if (this._opened) {
                this.closePopover();
                this.openPopover().then().catch(console.error);
            }
        }
        addTitle() {
            if (this.heading) {
                if (isNil(this._titleContainer)) {
                    this._titleContainer = document.createElement('div');
                    this._titleContainer.classList.add('sds-popover__header');
                    if (this._contentContainer) {
                        this._popover.insertBefore(this._titleContainer, this._contentContainer);
                    }
                    else {
                        this._popover.appendChild(this._titleContainer);
                    }
                }
                this._titleContainer.innerText = this.heading;
            }
            else {
                SdsPopover.removeElementIfExists(this._titleContainer);
                this._titleContainer = undefined;
            }
        }
        createContentContainer() {
            this._contentContainer = document.createElement('div');
            this._contentContainer.classList.add('sds-popover__content');
            this._popover.append(this._contentContainer);
        }
        addContent() {
            if (isNil(this._contentContainer)) {
                this.createContentContainer();
            }
            if (this._contentContainer.hasChildNodes() && !isEmpty(this.getContentSlot())) {
                this._popover.removeChild(this._contentContainer);
                this.createContentContainer();
            }
            for (const item of this.getContentSlot()) {
                this._contentContainer.appendChild(item);
            }
        }
        getFooterContent() {
            return [];
        }
        addFooter() {
            if (!isEmpty(this.getFooterContent())) {
                if (isNil(this._footerContainer)) {
                    this._footerContainer = document.createElement('div');
                    this._popover.append(this._footerContainer);
                }
                this._footerContainer.append(...this.getFooterContent());
            }
        }
        addArrow() {
            if (isNil(this._arrow)) {
                this._arrow = document.createElement('div');
                this._popover.append(this._arrow);
            }
        }
        setPopoverHeight() {
            const maxHeightWithHeading = 417;
            const maxHeight = 454;
            const titleHeight = 37;
            if (this.heading && this._titleContainer) {
                this._popoverHeight = Math.min(this._contentContainer.scrollHeight, maxHeightWithHeading);
                this._popoverHeight += this._titleContainer.clientHeight + titleHeight;
            }
            else {
                this._popoverHeight = Math.min(this._contentContainer.scrollHeight, maxHeight);
            }
        }
        updatePosition() {
            computePosition(this.getTriggerStrict(), this._popover, {
                placement: this._currentPlacement || this._position,
                middleware: [
                    flip({
                        fallbackAxisSideDirection: 'start',
                        crossAxis: false,
                    }),
                    shift(),
                    arrow({ element: this._arrow }),
                ],
            }).then(({ x, y, placement, middlewareData }) => {
                this._popover.style.transform = `translate(${x}px, ${y}px)`;
                this.clearPopoverClasses();
                this._popover.classList.add(this.getPopoverPositionClass(placement, middlewareData));
                const triggerRect = this.getTriggerStrict().getBoundingClientRect();
                const popoverShiftAmount = shiftPopover(this._popover.getBoundingClientRect(), getPositionClassName(placement, middlewareData), triggerRect, x, y, this._popoverOffset);
                if (popoverShiftAmount.translateString) {
                    this._popover.style.transform = popoverShiftAmount.translateString;
                }
                this.positionArrow(placement, triggerRect, middlewareData, {
                    x: popoverShiftAmount.x,
                    y: popoverShiftAmount.y,
                });
            }, e => console.error(e));
        }
        positionArrow(placement, triggerRect, middlewareData, popoverShiftAmount) {
            var _a, _b, _c, _d;
            const side = getPlacementWithoutAlignment(placement);
            const staticSide = {
                top: 'bottom',
                right: 'left',
                bottom: 'top',
                left: 'right',
            }[side];
            if ((triggerRect.width <= 40 && (side === 'top' || side === 'bottom')) ||
                (triggerRect.height <= 40 && (side === 'left' || side === 'right'))) {
                if (staticSide) {
                    this.addSmallTriggerClass();
                    this._arrow.className = 'sds-popover__arrow';
                    this._arrow.style.display = '';
                    this._arrow.style.left =
                        ((_a = middlewareData.arrow) === null || _a === void 0 ? void 0 : _a.x) != null
                            ? `${((_b = middlewareData.arrow) === null || _b === void 0 ? void 0 : _b.x) - popoverShiftAmount.x}px`
                            : '';
                    this._arrow.style.top =
                        ((_c = middlewareData.arrow) === null || _c === void 0 ? void 0 : _c.y) != null
                            ? `${((_d = middlewareData.arrow) === null || _d === void 0 ? void 0 : _d.y) - popoverShiftAmount.y}px`
                            : '';
                    this._arrow.style[staticSide] = `${-this._arrow.offsetWidth / 2}px`;
                }
            }
            else if ((triggerRect.width > 40 && (side === 'top' || side === 'bottom')) ||
                (triggerRect.height > 40 && (side === 'left' || side === 'right'))) {
                this.removeSmallTriggerClass();
                this._arrow.style.display = 'none';
            }
        }
        addSmallTriggerClass() {
            this._popover.classList.add('sds-popover--with-small-trigger');
        }
        removeSmallTriggerClass() {
            this._popover.classList.remove('sds-popover--with-small-trigger');
        }
        getPopoverPositionClass(placement, middlewareData) {
            return getClass(getPositionClassName(placement, middlewareData));
        }
        addPopover() {
            this.getTriggerStrict().classList.add(PopoverClass.HOVERED);
            document.body.appendChild(this._popover);
            this._clearAutoPositioner = autoUpdate(this.getTriggerStrict(), this._popover, () => this.updatePosition(), {
                animationFrame: true,
            });
        }
        removePopover() {
            var _a, _b;
            this.getTriggerStrict().classList.remove(PopoverClass.HOVERED);
            this.clearPopoverClasses();
            if (this.isExpanded && !this.isContent) {
                this.collapseContainer();
                this._popoverHeight = 0;
            }
            this._currentPlacement = undefined;
            this._popover.remove();
            this._clearAutoPositioner !== undefined && this._clearAutoPositioner();
            (_a = this._readAllButtonRenderedTemplate) === null || _a === void 0 ? void 0 : _a.setConnected(false);
            (_b = this._showMoreButtonRenderedTemplate) === null || _b === void 0 ? void 0 : _b.setConnected(false);
        }
        clearPopoverClasses() {
            this._popover.className = PopoverClass.MAIN;
        }
        async setBodyOverflows() {
            if (this._contentContainer.hasChildNodes()) {
                this._bodyOverflows = await this.calculateBodyOverflows(this._contentContainer.children[0], this._contentContainer);
            }
        }
        createToggle() {
            if (isNil(this._showMoreButton)) {
                this._showMoreButtonRenderedTemplate = render(this.createButton('show_more', 'tertiary', 'sds.show_more', 'md', () => this.toggleBodySize()), this._toggleContainer);
                this._showMoreButton = this._popover.querySelector('#show_more');
            }
        }
        addToggle() {
            if (!this.isContent) {
                if (this._bodyOverflows) {
                    this.addWithShowMoreClass();
                    this.addToggleContainer();
                    if (isNil(this._showMoreButton)) {
                        this.createToggle();
                    }
                    else {
                        this.revealShowMore();
                    }
                }
                else {
                    if (this._showMoreButton) {
                        this.hideShowMore();
                    }
                }
            }
            else {
                super.expand(this._contentContainer, 'sds-popover__content--expanded');
            }
        }
        addToggleContainer() {
            if (isNil(this._toggleContainer)) {
                this._toggleContainer = document.createElement('div');
                this._toggleContainer.classList.add('sds-popover__show-more');
                this._popover.insertBefore(this._toggleContainer, this._footerContainer);
            }
        }
        createButton(id, type, label, size, handler) {
            return html ` <sds-button
            id="${id}"
            type=${type}
            label="${translate(label)}"
            size="${size}"
            @click="${() => handler()}"
        ></sds-button>`;
        }
        async addReadAll() {
            await this.setBodyOverflows();
            if (this.isReadAllNeeded()) {
                this.addWithReadAllClass();
                if (isNil(this._readAllButton)) {
                    this.createReadAll();
                }
                else {
                    this.showReadAll();
                }
            }
            else {
                this.hideReadAll();
            }
        }
        createReadAll() {
            this.addToggleContainer();
            this._readAllButtonRenderedTemplate = render(this.createButton('read_all', 'primary', 'sds.read_all', 'md', () => this.openModal()), this._toggleContainer, this._showMoreButton ? { renderBefore: this._showMoreButton } : undefined);
            this._readAllButton = this._toggleContainer.querySelector('#read_all');
        }
        isReadAllNeeded() {
            return this.isExpanded && this._bodyOverflows;
        }
        openModal() {
            this.createModal();
            this.prepareModalContent();
            this.initModal();
            this.closePopover();
        }
        prepareModalContent() {
            this._modalContainer = document.createElement('div');
            this._modalContainer.setAttribute('slot', 'content');
            for (const child of this._contentContainer.children) {
                this._modalContainer.append(child);
            }
        }
        createModal() {
            this._modalRenderedTemplate = render(this.getModalTemplate(), document.body);
        }
        initModal() {
            var _a;
            const modal = document.body.querySelector('sds-modal');
            if (modal) {
                modal.appendChild(this._modalContainer);
                modal.setAttribute('open', '');
                modal.addEventListener('sds.modal.closed', this.modalClosedListener);
                (_a = this._modalRenderedTemplate) === null || _a === void 0 ? void 0 : _a.setConnected(true);
            }
        }
        closeModal() {
            var _a, _b;
            (_a = document.body.querySelector('sds-modal')) === null || _a === void 0 ? void 0 : _a.removeAttribute('open');
            (_b = this._modalRenderedTemplate) === null || _b === void 0 ? void 0 : _b.setConnected(false);
        }
        getModalTemplate() {
            return html ` <sds-modal size="md" title="${this.heading}">
            <sds-button
                slot="primary-action"
                label="${translate('sds.close')}"
                @click="${() => this.closeModal()}"
            ></sds-button>
        </sds-modal>`;
        }
        hideReadAll() {
            var _a;
            if (this._readAllButton) {
                this._readAllButton.style.display = 'none';
                (_a = this._readAllButtonRenderedTemplate) === null || _a === void 0 ? void 0 : _a.setConnected(false);
                this.removeWithReadAllClass();
            }
        }
        showReadAll() {
            var _a;
            if (this._readAllButton) {
                this._readAllButton.style.display = '';
                (_a = this._readAllButtonRenderedTemplate) === null || _a === void 0 ? void 0 : _a.setConnected(true);
            }
        }
        revealShowMore() {
            var _a;
            if (this._showMoreButton) {
                this._showMoreButton.style.display = '';
                (_a = this._showMoreButtonRenderedTemplate) === null || _a === void 0 ? void 0 : _a.setConnected(true);
                this.addWithShowMoreClass();
            }
        }
        hideShowMore() {
            var _a;
            if (this._showMoreButton) {
                this._showMoreButton.style.display = 'none';
                (_a = this._showMoreButtonRenderedTemplate) === null || _a === void 0 ? void 0 : _a.setConnected(false);
                this.removeWithShowMoreClass();
            }
        }
        addWithShowMoreClass() {
            this._contentContainer.classList.add('sds-popover__content--with-show-more');
        }
        removeWithShowMoreClass() {
            this._contentContainer.classList.remove('sds-popover__content--with-show-more');
        }
        addWithReadAllClass() {
            this._contentContainer.classList.add('sds-popover__content--expanded-with-read-all');
        }
        removeWithReadAllClass() {
            this._contentContainer.classList.remove('sds-popover__content--expanded-with-read-all');
        }
    };
    _SdsPopover_openOn_accessor_storage = new WeakMap();
    _SdsPopover__trigger_accessor_storage = new WeakMap();
    _SdsPopover__opened_accessor_storage = new WeakMap();
    _SdsPopover_contentSlot_accessor_storage = new WeakMap();
    _SdsPopover_textSlot_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsPopover");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _set_position_decorators = [property()];
        _openOn_decorators = [property({ type: String, attribute: 'open-on' })];
        __trigger_decorators = [queryAssignedElements({ slot: 'trigger' })];
        __opened_decorators = [state()];
        _contentSlot_decorators = [query('slot[name="content"]')];
        _textSlot_decorators = [query('slot[name="text"]')];
        __esDecorate(_classThis, null, _set_position_decorators, { kind: "setter", name: "position", static: false, private: false, access: { has: obj => "position" in obj, set: (obj, value) => { obj.position = value; } }, metadata: _metadata }, null, _instanceExtraInitializers);
        __esDecorate(_classThis, null, _openOn_decorators, { kind: "accessor", name: "openOn", static: false, private: false, access: { has: obj => "openOn" in obj, get: obj => obj.openOn, set: (obj, value) => { obj.openOn = value; } }, metadata: _metadata }, _openOn_initializers, _openOn_extraInitializers);
        __esDecorate(_classThis, null, __trigger_decorators, { kind: "accessor", name: "_trigger", static: false, private: false, access: { has: obj => "_trigger" in obj, get: obj => obj._trigger, set: (obj, value) => { obj._trigger = value; } }, metadata: _metadata }, __trigger_initializers, __trigger_extraInitializers);
        __esDecorate(_classThis, null, __opened_decorators, { kind: "accessor", name: "_opened", static: false, private: false, access: { has: obj => "_opened" in obj, get: obj => obj._opened, set: (obj, value) => { obj._opened = value; } }, metadata: _metadata }, __opened_initializers, __opened_extraInitializers);
        __esDecorate(_classThis, null, _contentSlot_decorators, { kind: "accessor", name: "contentSlot", static: false, private: false, access: { has: obj => "contentSlot" in obj, get: obj => obj.contentSlot, set: (obj, value) => { obj.contentSlot = value; } }, metadata: _metadata }, _contentSlot_initializers, _contentSlot_extraInitializers);
        __esDecorate(_classThis, null, _textSlot_decorators, { kind: "accessor", name: "textSlot", static: false, private: false, access: { has: obj => "textSlot" in obj, get: obj => obj.textSlot, set: (obj, value) => { obj.textSlot = value; } }, metadata: _metadata }, _textSlot_initializers, _textSlot_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsPopover = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsPopover = _classThis;
})();
export { SdsPopover };
